import { useEffect, useMemo, useState } from 'react'
import { isCustomDevice } from 'store/resolutions'
import { DefaultTheme } from 'styled-components'
import { theme as styledTheme } from 'styles/theme'

const TicketTypeRadioDots = ({
    isChecked,
    theme,
}: {
    isChecked: boolean
    theme?: DefaultTheme
}) => {
    const color = useMemo(() => {
        if (theme) {
            if (isChecked) {
                return styledTheme.colors.primary_500
            }
            return styledTheme.colors.darkmode_900
        }
        if (isChecked) {
            return styledTheme.colors.primary_500
        }
        return styledTheme.colors.grayscale_0
    }, [
        theme,
        isChecked,
        styledTheme.colors.primary_500,
        styledTheme.colors.grayscale_0,
    ])

    const [areMobileDots, setAreMobileDots] = useState(false)

    const fillColor = useMemo(() => {
        if (theme) return styledTheme.colors.darkmode_900
        return styledTheme.colors.grayscale_0
    }, [theme, styledTheme.colors.darkmode_900, styledTheme.colors.grayscale_0])

    useEffect(() => {
        if (isCustomDevice(415)) {
            setAreMobileDots(true)
        }
        const handler = () => {
            if (isCustomDevice(415)) {
                setAreMobileDots(true)
            } else {
                setAreMobileDots(false)
            }
        }

        window.addEventListener('resize', handler)

        return () => {
            window.removeEventListener('resize', handler)
        }
    }, [])

    if (areMobileDots) {
        return (
            <svg width="414" height="16" viewBox="0 0 414 16" fill="none">
                <circle
                    cy="8"
                    r="7"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                    cx="8"
                />
                <circle
                    cx="23.6087"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="36.2174"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="48.826099"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="61.434799"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="74.043503"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="86.652199"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="99.260902"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="111.87"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="124.478"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="137.08701"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="149.696"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="162.304"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="174.91299"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="187.522"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="200.13"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="212.739"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="225.34801"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="237.95599"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="250.565"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="263.17401"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="275.78299"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="288.39099"
                    cy="8"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="301.18951"
                    cy="7.9777918"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="314.17551"
                    cy="8.0015612"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="326.78452"
                    cy="8.0015612"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="339.39252"
                    cy="8.0015612"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="352.00153"
                    cy="8.0015612"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="364.61053"
                    cy="8.0015612"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="377.21851"
                    cy="8.0015612"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="389.82751"
                    cy="8.0015612"
                    r="4"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="406"
                    cy="8"
                    r="7"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
            </svg>
        )
    } else {
        return (
            <svg
                width="710"
                height="22"
                viewBox="0 0 710 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle
                    cy="11"
                    r="10"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="26.875"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="48.75"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="70.625"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="92.5"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="114.375"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="136.25"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="158.125"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="180"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="201.875"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="223.75"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="245.625"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="267.5"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="289.375"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="311.25"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="333.125"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="355"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="376.875"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="398.75"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="420.625"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="442.5"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="464.375"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="486.25"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="508.125"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="530"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="551.875"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="573.75"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="595.625"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="617.5"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="639.375"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="661.25"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="683.125"
                    cy="11"
                    r="5"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
                <circle
                    cx="710"
                    cy="11"
                    r="10"
                    fill={fillColor}
                    stroke={color}
                    strokeWidth="2"
                />
            </svg>
        )
    }
}

export default TicketTypeRadioDots
